import { THEME } from '@anytag/shared-constants';
import { TrackingReferral } from '@anytag/shared-organisms';
import { useMarketplaceDetailsContext } from '../marketplace-details-context';

export const MarketplaceTrackingReferral = () => {
  const { marketplace } = useMarketplaceDetailsContext();

  return (
    <TrackingReferral
      css={{ boxShadow: THEME.shadows.boxShadow }}
      campaign={{ id: marketplace.id, title: marketplace.title, type: 'marketplace' }}
    />
  );
};
